module.exports = __webpack_public_path__ + "static/media/fruit.cd268323.png";